export function getTags(str?: string): string[] {
  if (!str) return [];
  if (!str.includes('#')) return [str];
  const s = str.split('#').map(tag => tag.trim());
  return s.filter(tag => tag !== '' && tag !== ' ');
}
